export default __webpack_public_path__ + "static/media/mercosur.add76272.svg";